/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import React from 'react';

import Accordion from './Accordion.js';
import './FAQ.scss';

const FAQ = () => {
  const items = [
    {
      question: 'Which cost basis method is right for me? ',
      answer: (
        <div>
          <p style={{ marginBottom: '5px' }}>
            T. Rowe Price&#39;s default method for reporting cost basis for
            mutual fund accounts is Average Cost, one of the most popular
            methods requiring the least amount of recordkeeping. Average Cost
            and other cost basis methods are explained below.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>Average Cost: </strong>Default method for mutual funds. The
            cost of shares held, including reinvested dividends and capital gain
            distributions, divided by the number of shares held, is used to
            compute the average cost of each share. Shares are disposed of on a
            first in first out basis. This method is available only for mutual
            funds and DRIPs.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>First In First Out (FIFO): </strong> Default method for
            DRIPs, equities (stocks), options, and other securities. Shares
            acquired first are sold or disposed of first.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>Last In First Out (LIFO): </strong>
            Shares acquired last are sold or disposed of first.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>High Cost: </strong>
            Highest-cost shares are sold or disposed of first.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>Low Cost: </strong>
            Lowest-cost shares are sold or disposed of first.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>Loss/Gain Utilization: </strong>
            Evaluates losses and gains and also strategically selects lots based
            on the loss/gain in conjunction with the holding period.
          </p>
          <p style={{ marginBottom: '5px' }}>
            <strong>Specific Lot Identification: </strong>
            The actual cost basis of each share (stock or mutual fund) or other
            security you designated for sale at the time of sale is used to
            calculate the gain or loss from such sale.
          </p>
          <p style={{ marginBottom: '5px' }}>
            Please note: Specific Lot Identification cannot be selected online
            as a cost basis method for your mutual fund shares, except for
            shares held in a T. Rowe Price Brokerage account. To sell or
            exchange shares using Specific Lot Identification as the cost basis
            method, first ensure your current method is not set to Average Cost
            (if it is, you may change it online to another method such as FIFO).
            Then, call us at 1-888-898-9677 to specify the shares for
            transaction.
          </p>
        </div>
      )
    },
    {
      question:
        'Where can I find more information about Cost Basis Regulations? ',
      answer: (
        <div>
          More information can be found on our{' '}
          <a
            style={{ whiteSpace: 'nowrap', color: '#006894' }}
            href="https://www.troweprice.com/personal-investing/resources/planning/tax/education/cost-basis-accounting-and-calculation.html"
            target="_blank"
            rel="noopener noreferrer">
            Cost Basis Accounting and Regulations page.
          </a>{' '}
        </div>
      )
    },
    {
      question: 'Where can I view the cost basis method for each holding in my Brokerage account? ',
      answer: (
        <span>
          Cost basis method can be viewed on the Holdings page by clicking the dropdown for the individual holding.
            Default cost basis methods may not be applicable to your account type or to the holdings in your
            account. {' '}
        </span>
      )
    }
  ];
  return (
    <div className="container">
      <div className="text-section">
        <div className="sub-title">
          <div className="app-component"></div>
          <div>
            {items.map(({ question, answer }, key) => (
              <Accordion key={key} question={question} answer={answer} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
